export default "__VITE_ASSET__DZqh_Vi0__"